import GridTimeEditCell from '../../components/GridTimeEditCell';
import type { GridRenderEditCellParams } from '../../lib/dataGrid';

/** The two time-of-day fields of a time entry, as a column can name them. */
type TimeField = 'startTime' | 'endTime';

/**
 * Each of the pair is bounded by the other: a start must fall before its end,
 * an end after its start (GridTimeEditCell makes both strict).
 */
const SIBLING_BOUND: Record<
    TimeField,
    { beforeField?: string; afterField?: string }
> = {
    startTime: { beforeField: 'endTime' },
    endTime: { afterField: 'startTime' }
};

/**
 * The Von/Bis edit cell shared by both Zeiterfassung grids: a 24h picker that
 * offers no future times and none that would cross the row's other time.
 *
 * Pass `cellError` for the field grid's non-blocking flags. The office grid
 * omits it: its `preProcessEditCellProps` already leaves an `error` on
 * `params`, which the spread carries through.
 */
export function timeEditCell(
    field: TimeField,
    cellError?: (params: GridRenderEditCellParams) => string | null
) {
    return function renderTimeEditCell(params: GridRenderEditCellParams) {
        return (
            <GridTimeEditCell
                {...params}
                disableFuture
                {...SIBLING_BOUND[field]}
                {...(cellError ? { error: cellError(params) } : {})}
            />
        );
    };
}
